import { render, staticRenderFns } from "./exam-result-detail.vue?vue&type=template&id=644714a0&scoped=true&"
import script from "./exam-result-detail.vue?vue&type=script&lang=js&"
export * from "./exam-result-detail.vue?vue&type=script&lang=js&"
import style0 from "./exam-result-detail.vue?vue&type=style&index=0&id=644714a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644714a0",
  null
  
)

export default component.exports